import React from 'react'

import MdRightAero from '@icons/line-md-right-aero.inline.svg'
import MdLeftAero from '@icons/line-md-left-aero.inline.svg'

import LgRightAero from '@icons/line-xl-right-aero.inline.svg'
import LgLeftAero from '@icons/line-xl-left-aero.inline.svg'

import LgLine from '@icons/lg-line.inline.svg'
import LgRight from '@icons/lg-lr.inline.svg'
import LgLeft from '@icons/lg-rl.inline.svg'

import MdLine from '@icons/md-line.inline.svg'
import MdRight from '@icons/md-lr.inline.svg'
import MdLeft from '@icons/md-rl.inline.svg'

import SmLine from '@icons/sm-line.inline.svg'
import SmRight from '@icons/sm-lr.inline.svg'
import SmLeft from '@icons/sm-rl.inline.svg'

interface ILinesSet {
  line: React.ReactNode
  left: React.ReactNode
  right: React.ReactNode
}
export interface ILines {
  lg: ILinesSet
  md: ILinesSet
  sm: ILinesSet
}

export const sarovLines: ILines = {
  lg: {
    line: <LgLine />,
    left: <LgLeft />,
    right: <LgRight />,
  },
  md: {
    line: <MdLine />,
    left: <MdLeft />,
    right: <MdRight />,
  },
  sm: {
    line: <SmLine />,
    left: <SmLeft />,
    right: <SmRight />,
  },
}

export const aeroLines: ILines = {
  lg: {
    line: <LgLine />,
    left: <LgLeftAero />,
    right: <LgRightAero />,
  },
  md: {
    line: <MdLine />,
    left: <MdLeftAero />,
    right: <MdRightAero />,
  },
  sm: {
    line: <SmLine />,
    left: <SmLeft />,
    right: <SmRight />,
  },
}
